import {TemplateRef} from '@angular/core';
import {KeyValueObj} from '../../../../generated/generated-core.model';
import {MxFilterButtonsConfig} from '../../mx-grid/services/mx-filter-button.model';
import {MxGridCustomizerEvent} from '../../mx-grid/services/mx-grid-customizer-event';

export class MxReportViewInputFilterDefault {
    field: string;
    value?: string | number | KeyValueObj;
    disabled?: boolean;
    hidden?: boolean;
}

export class MxReportViewCustomizerEvent extends MxGridCustomizerEvent {

    private _filterButtonsTemplate: TemplateRef<any>;
    private _reportName: string;
    private _filterDefaults: MxReportViewInputFilterDefault[] = [];
    private _filterButtonConfig: Array<MxFilterButtonsConfig> = [];
    private _coreReports: boolean = true;
    private _outputExcludes: Array<string> = [];
    private _hideFilters: boolean = false;
    private _fullFilterReset: boolean = false;

    /** Add possibility to add filter button from ng-template and customize it */
    customizeFilterButtonsTemplate(filterButtonsTemplate: TemplateRef<any>): this {
        this._filterButtonsTemplate = filterButtonsTemplate;
        return this;
    }

    get filterButtonsTemplate(): TemplateRef<any> {
        return this._filterButtonsTemplate;
    }

    /** Add possibility to customize default filter buttons in report view
      * such as: 'Search', 'Reset filters', 'Export report' and 'Report url'. */
    customizeFilterButtons(filterButtonsConfig: MxFilterButtonsConfig): this {
        this._filterButtonConfig.push(filterButtonsConfig);
        return this;
    }

    /** Add possibility to exclude(hide) specific outputs on UI which defined in report template */
    customizeOutputExcludes(columns: Array<string>): this {
        this._outputExcludes.push(...columns);
        return this;
    }

    get outputExcludes(): Array<string> {
        return this._outputExcludes;
    }

    get filterButtons(): Array<MxFilterButtonsConfig> {
        return this._filterButtonConfig;
    }

    /** Sets the report name (should match the name defined in the XML reports configuration)
      * for example: 'AFFILIATE_PAYMENT_ACCOUNTS', 'AUTOPROCESS_TRANSACTIONS' etc. */
    customizeReportName(reportName: string): this {
        this._reportName = reportName;
        return this;
    }

    get reportName(): string {
        return this._reportName;
    }

    /** Sets default filter values or hides/disables them in the report view */
    customizeFilterDefaults(filterDefaults: MxReportViewInputFilterDefault[] = []): this {
        this._filterDefaults = filterDefaults;
        return this;
    }

    get filterDefaults(): MxReportViewInputFilterDefault[] {
        return this._filterDefaults;
    }

    /** Define if the report is a core report */
    customizeIsCoreReport(load: boolean): this {
        this._coreReports = load;
        return this;
    }

    get isCoreReport(): boolean {
        return this._coreReports;
    }

    /** Add possibility to hide filters section in report view */
    customizeHideFilters(initValue: boolean): this {
        this._hideFilters = initValue;
        return this;
    }

    get isFilterHidden(): boolean {
        return this._hideFilters;
    }

    /** Checks if `fullFilterReset` is `false`.
      * If so, restores the filter form to its initial state.
      * Otherwise, emits an empty set of filter parameters for a complete reset. */
    customizeFullFilterReset(fullReset: boolean): this {
        this._fullFilterReset = fullReset;
        return this;
    }

    get fullFilterReset(): boolean {
        return this._fullFilterReset;
    }
}
